import React from 'react';

import { Radio, Space } from 'antd';

import { IBVControl } from '../../../models/BVControls/IBVControl';
import { IBVOption } from '../../../models/BVControls/IBVOption';

import './bv-radio-group.scss';

import BVControl from '../BVControl/bv-control';

interface IBVRadioGroup extends IBVControl {
    data: IBVOption[];
    properties: any;
}

const BVRadioGroup: React.FunctionComponent<IBVRadioGroup> = ({ className, data, errorMessage, infoMessage, label, properties, required }) => (
    <BVControl className={`bv-radio-group ${className}`} errorMessage={errorMessage} infoMessage={infoMessage} label={label} required={required}>
        <Radio.Group {...properties}>
            <Space direction="horizontal">
                {data.map((dataItem, dataIndex) => (
                    <Radio key={dataIndex} value={dataItem.value}>{dataItem.label}</Radio>
                ))}
            </Space>
        </Radio.Group>
    </BVControl>
);

export default BVRadioGroup;